import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectRefreshData = createFeatureSelector<boolean>('refreshData');

export const selectRefreshDataState = createSelector(
    selectRefreshData,
    (state: boolean) => state,
);
